import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LeftMenu from './LeftMenu';
import './_styles_/LeftMenuWrapper.css';
import { onActionKey } from '../utils';

function LeftMenuWrapper() {
    const { t } = useTranslation();
    const [isLeftMenuVisible, toggleLeftMenuVisibility] = useState(true);
    const actionHandler = () => toggleLeftMenuVisibility(!isLeftMenuVisible);
    const toggleLeftMenuTitle = t('left-menu.toggle-left-menu');
    return (
        <div className={`left-menu-wrapper ${isLeftMenuVisible ? 'active' : ''}`}>
            <LeftMenu />
            <div className={`left-menu-toggle ${isLeftMenuVisible ? 'active' : ''}`} onClick={actionHandler} onKeyUp={onActionKey(actionHandler)} role="button" tabIndex={0} title={toggleLeftMenuTitle} aria-label={toggleLeftMenuTitle}>
                <FontAwesomeIcon icon="ellipsis-v" />
            </div>
        </div>
    );
}

export default LeftMenuWrapper;
